import script from "./rec-accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-accordion.vue?vue&type=script&lang=ts&setup=true"

import "./rec-accordion.vue?vue&type=style&index=0&id=f73744bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f73744bc"]])

export default __exports__